import { TranslationsApiService } from '../api/translations-api.service';
import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppTranslateLoader implements TranslateLoader {
  constructor(private api: TranslationsApiService) {
  }

  getTranslation(lang: string): Observable<any> {
    return this.api.getTranslations(lang);
  }
}
